import React, { useRef, useState, useEffect } from 'react';
import {
  Box,
  Typography,
  LinearProgress,
  Tab,
  Button,
} from '@mui/material';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import MonthYearPicker from '../../components/Date-range-picker/MonthSelector';
import UserActivity from '../../components/UserActivity';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SingalUserImageSelect from '../../components/DemoTabs/SingalUserImageSelect';
import TableDownloadBtn from '../../components/dropdown-select/TableDownloadBtn';
import WidgetsDropdown from '../../layout/WidgetsDropdown';
import TimeZoneDropdown from '../../components/dropdown-select/TimezoneDropdown';
import ScreenShortFilter from './ScreenShortFilter';
import DownloadScreenshots from '../../components/Projects/DownloadScreenshots';
import AllNotes from '../../components/Projects/AllNotes';
import SettingsIcon from '@mui/icons-material/Settings';



import WorkSummary from '../../components/WorkSummary';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Link } from 'react-router-dom';
const generateDates = (year, month) => {
  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const result = [];
  const totalDays = new Date(year, month + 1, 0).getDate();

  for (let i = 1; i <= totalDays; i++) {
    const date = new Date(year, month, i);
    result.push({
      day: days[date.getDay()],
      date: String(i).padStart(2, '0'),
      time: '00:00:00',
      percent: Math.floor(Math.random() * 100),
    });
  }

  return result;
};

export default function ScreenDateTabs() {


  const scrollContainerRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedMonthYear, setSelectedMonthYear] = useState({ month: 3, year: 2025 });
  const [value, setValue] = React.useState('1');

  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  useEffect(() => {
    const slider = scrollContainerRef.current;
    if (!slider) return;

    const handleMouseDown = (e) => {
      isDown.current = true;
      slider.classList.add('active');
      startX.current = e.pageX - slider.offsetLeft;
      scrollLeft.current = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown.current = false;
      slider.classList.remove('active');
    };

    const handleMouseUp = () => {
      isDown.current = false;
      slider.classList.remove('active');
    };

    const handleMouseMove = (e) => {
      if (!isDown.current) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX.current) * 1;
      slider.scrollLeft = scrollLeft.current - walk;
    };

    slider.addEventListener('mousedown', handleMouseDown);
    slider.addEventListener('mouseleave', handleMouseLeave);
    slider.addEventListener('mouseup', handleMouseUp);
    slider.addEventListener('mousemove', handleMouseMove);

    return () => {
      slider.removeEventListener('mousedown', handleMouseDown);
      slider.removeEventListener('mouseleave', handleMouseLeave);
      slider.removeEventListener('mouseup', handleMouseUp);
      slider.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const scrollByOffset = (offset) => {
    scrollContainerRef.current?.scrollBy({
      left: offset,
      behavior: 'smooth',
    });
  };

  const handleClick = (index) => {
    setActiveIndex(index);
    const container = scrollContainerRef.current;
    const item = container?.children[index];
    if (item && container) {
      const itemOffset = item.offsetLeft;
      const itemWidth = item.offsetWidth;
      const containerWidth = container.offsetWidth;

      container.scrollTo({
        left: itemOffset - (containerWidth / 2 - itemWidth / 2),
        behavior: 'smooth',
      });
    }
  };

  const handleMonthChange = (index) => {
    setSelectedMonthYear((prev) => ({ ...prev, month: index }));
    setActiveIndex(0);
    scrollContainerRef.current.scrollLeft = 0;
  };

  const goPrevMonth = () => {
    setSelectedMonthYear((prev) => {
      const newMonth = prev.month - 1;
      if (newMonth < 0) return { month: 11, year: prev.year - 1 };
      return { month: newMonth, year: prev.year };
    });
    setActiveIndex(0);
  };

  const goNextMonth = () => {
    setSelectedMonthYear((prev) => {
      const newMonth = prev.month + 1;
      if (newMonth > 11) return { month: 0, year: prev.year + 1 };
      return { month: newMonth, year: prev.year };
    });
    setActiveIndex(0);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { month, year } = selectedMonthYear;
  const dates = generateDates(year, month);

  const [selectedUser, setSelectedUser] = useState('');

  const userList = [
    { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
    { name: 'Alice Smith', image: null },
    { name: 'Michael Johnson', image: '' },
  ];

  const [openDownloadScreenshots, setOpenDownloadScreenshots] = useState(false);
  const [openAllNotes, setOpenAllNotes] = useState(false);

  return (
    <Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, marginBottom: '20px', }}>
        <Typography className="fw-semibold mb-0" sx={{ fontSize: '24px', color: '#1A1F36' }}>Screenshots</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1 }}>
          <Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}>
            <img src='./assets/images/app-activity/insights/question-icon.svg' className='img-fluid' alt='question icon' />
          </Button>
          <Link to='/feature'>
            <Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><SettingsIcon /></Button>

          </Link>
        </Box>
      </Box>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box className="card-body p-20 bg-base border rounded-3 mt-24">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'Space-between', gap: '10px', marginBottom: '30px', flexWrap: 'wrap' }}>
              <Box >
                <TabList
                  onChange={handleChange}
                  aria-label="styled tabs"
                  TabIndicatorProps={{ style: { display: 'none' } }}
                  sx={{
                    minHeight: 'auto',
                    display: 'flex',
                    gap: '15px',
                  }}
                >
                  <Tab
                    label="Every 10 Mins"
                    value="1"
                    sx={{
                      textTransform: 'none',
                      minHeight: 'auto',
                      px: 3,
                      py: 1,
                      borderRadius: '60px',
                      fontWeight: 500,
                      color: '#64748B',
                      border: '1px solid #D9D9D9',
                      background: '#FFF',
                      '&.Mui-selected': {
                        color: '#fff',
                        background: '#004DFF', // Change to your active color
                        border: '1px solid #004DFF',
                      },
                    }}
                  />
                  <Tab
                    label="All Screenshots"
                    value="2"
                    sx={{
                      textTransform: 'none',
                      minHeight: 'auto',
                      marginLeft: '15px',
                      px: 3,
                      py: 1,
                      borderRadius: '60px',
                      fontWeight: 500,
                      color: '#64748B',
                      border: '1px solid #D9D9D9',
                      background: '#FFF',
                      '&.Mui-selected': {
                        color: '#fff',
                        background: '#004DFF',
                        border: '1px solid #004DFF',
                      },
                    }}
                  />
                </TabList>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', }}>
                <SingalUserImageSelect
                  label="Select User"
                  options={userList}
                  selectedValue={selectedUser}
                  onChange={setSelectedUser}
                />
                {/* <TableDownloadBtn /> */}
                <TimeZoneDropdown />
                <ScreenShortFilter />

                <Button onClick={() => setOpenDownloadScreenshots(true)} sx={{ border: '1px solid #E5E8EB', minWidth: '32px', height: '32px', color: '#64748B', borderRadius: '8px' }}><KeyboardTabIcon sx={{ fontSize: '18px', transform: 'rotate(90deg)' }} /></Button>
                <Button onClick={() => setOpenAllNotes(true)} sx={{ border: '1px solid #E5E8EB', minWidth: '32px', height: '32px', color: '#64748B', borderRadius: '8px' }}>
                  <img src='./assets/images/app-activity/note-icon.svg' className='img-fluid' alt='note icon' />
                </Button>
                <DownloadScreenshots open={openDownloadScreenshots} onClose={() => setOpenDownloadScreenshots(false)} />
                <AllNotes open={openAllNotes} onClose={() => setOpenAllNotes(false)} />
              </Box>
            </Box>
            <Box display={'grid'} justifyContent={'center'} alignItems={"center"} sx={{ gridTemplateColumns: 'repeat(3, 1fr)', textAlign: 'center', }}>
              <Typography sx={{ fontSize: '17px', color: '#373737', fontWeight: '600', textAlign: 'left' }}>Today’s Screenshots</Typography>
              <Box sx={{ width: "100%", }}>
                <MonthYearPicker
                  month={month}
                  year={year}
                  onPrev={goPrevMonth}
                  onNext={goNextMonth}
                  onSelectMonth={handleMonthChange}
                />
              </Box>
            </Box>

            <Box display="flex" alignItems="center" gap={1} mt={2}>
              <Button variant="outlined" onClick={() => scrollByOffset(-200)} sx={{ width: '38px', height: '38px', background: '#fff', borderRadius: '50px', minWidth: '38px', border: '1px solid #E5E8EB', }}><NavigateBeforeIcon sx={{ color: '#595959', }} /></Button>

              <Box
                ref={scrollContainerRef}
                sx={{
                  display: 'flex',
                  overflowX: 'auto',
                  gap: 1,
                  pb: '29px',
                  cursor: 'grab',
                  scrollbarWidth: 'none',
                  flex: 1,
                  '&::-webkit-scrollbar': { display: 'none' },
                }}
              >
                {dates.map((d, i) => (
                  <Box
                    key={i}
                    textAlign="center"
                    p={1}
                    border={i === activeIndex ? '1px solid #004DFF' : '1px solid #DFDFDF'}
                    borderRadius={0}
                    sx={{ cursor: 'pointer', flexShrink: 0, position: 'relative', minWidth: { xl: '170px', lg: '160px', md: '140px', sm: '160px' } }}
                    onClick={() => handleClick(i)}
                  >
                    <Typography sx={{ fontSize: '12px', color: '#64748B', fontFamily: 'Manrope' }}>{d.day}</Typography>
                    <Typography variant="h6" fontWeight={600} sx={{ fontSize: '18px', color: '#1A1F36', fontFamily: 'Manrope' }}>{d.date}</Typography>
                    <Typography variant="caption" sx={{ fontSize: '16px', color: '#1A1F36', fontFamily: 'Manrope' }}>{d.time}</Typography>

                    <Box display="flex" alignItems="center" gap={1} mt={1}>
                      <LinearProgress
                        variant="determinate"
                        value={d.percent}
                        sx={{
                          flex: 1,
                          height: 6,
                          borderRadius: 4,
                          backgroundColor: '#f0f0f0',
                          '& .MuiLinearProgress-bar': {
                            backgroundColor: d.percent > 70 ? '#4caf50' : d.percent > 40 ? '#ff9800' : '#f44336',
                          },
                        }}
                      />
                      <Typography variant="caption" width={28}>{d.percent}%</Typography>
                    </Box>

                    {/* Bottom arrow for active index */}
                    {i === activeIndex && (
                      <ArrowDropUpIcon
                        sx={{
                          position: 'absolute',
                          bottom: -30,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          color: '#373737',
                          fontSize: 20, width: '3rem', height: '3rem',
                        }}
                      />
                    )}
                  </Box>
                ))}
              </Box>

              <Button variant="outlined" onClick={() => scrollByOffset(200)} sx={{ width: '38px', height: '38px', background: '#fff', borderRadius: '50px', minWidth: '38px', border: '1px solid #E5E8EB', }}><NavigateNextIcon sx={{ color: '#595959', }} /></Button>
            </Box>
          </Box>

          {/* Tab 1 */}
          <TabPanel value="1" sx={{ padding: '0', marginTop: '24px', }}>
            <Box>
              <WorkSummary />
              {[...Array(8)].map((_, i) => (
                <UserActivity
                  key={i}
                  showSummary={true}
                  showIndexCircle={true}
                  showProgress={true}
                  limit={6}
                />
              ))}
            </Box>
          </TabPanel>

          {/* Tab 2 */}
          <TabPanel value="2" sx={{ padding: '0', marginTop: '24px', }}>
            <Box>
              <UserActivity
                showSummary={false}
                showIndexCircle={false}
                showProgress={false}
              />
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
}